<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :auto-fetch="false"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="true"
      serial-width="100"
      :selection="hasBtn && selection"
      :stripe="false"
      right-toolbar-hide
      :hide-search="hideSearch"
      row-key="id"
      :reset-data="resetDataFn"
      tree-select-auto-parent
      lazy
      :load="loadMethod"
      :search-btn-hide="true"
      :row-style="rowStyleFun"
      @handleSelectionChange="handleSelectionChange"
      @afterFetchOriginalData="afterFetchOriginalData"
    >
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />

              <template v-else-if="col.prop === 'tags'">
                <BjTagList :tag-code-string="scope.row.tags" />
              </template>

              <template v-else-if="col.prop === 'standardSkuCode'">
                  <el-button type="text" @click="toView(scope.row)">{{ scope.row.standardSkuCode }}</el-button>
                  <BjCopyIcon v-if="scope.row.standardSkuCode" :copy="scope.row.standardSkuCode" />
              </template>

              <template v-else-if="col.prop === 'deliveryTime'">
                  {{ scope.row[col.prop] }}
              </template>

              <template v-else-if="col.prop === 'refundFlag'">
                <el-tag :type="scope.row.refundFlag ? 'success' : 'info'">{{
                  $t(STATUS_YES_NUM.bjGet(!!scope.row.refundFlag))
                }}</el-tag>
              </template>

              <template
                v-else-if="
                  col.prop.toLocaleLowerCase().includes('amount') ||
                    col.prop.toLocaleLowerCase().includes('price')
                "
              >
                {{ $number2money(scope.row[col.prop]) }}
              </template>

              <template v-else-if="col.prop === 'deliveryStatus'">
                {{
                  $t([
                    ...ORDER_INTERNAL_SKU_DELIVER_STATUS_LIST,
                    ...ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST,
                  ].bjGet(scope.row[col.prop]))
                }}
              </template>
              <template v-else-if="col.prop === 'receivingStatus'">
                {{
                  $t([
                    ...ORDER_INTERNAL_SKU_RECEIVING_STATUS_LIST,
                    ...ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST,
                  ].bjGet(scope.row[col.prop]))
                }}
              </template>
              <!-- #ifndef OPEN-SOURCE -->
              <template v-else-if="col.prop === 'preemptionStatus'">
                <span :style="`color:${scope.row.isColorRed? 'red':''}`">
                  {{
                    $t([
                      ...ORDER_INTERNAL_SKU_PREEMPT_STATUS_LIST,
                      ...ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST,
                    ].bjGet(scope.row[col.prop]))
                  }}
                </span>
              </template>
              <template v-else-if="col.prop === 'sourceStatus'">
                <span :style="`color:${scope.row.isColorRed? 'red':''}`">
                  {{
                    $t([
                      ...ORDER_INTERNAL_SKU_SOURCE_STATUS_LIST,
                      ...ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST,
                    ].bjGet(scope.row[col.prop]))
                  }}
                </span>
              </template>
              <template v-else-if="col.prop === 'syncPreempStatus'">
                {{
                  $t([
                    ...ORDER_INTERNAL_SKU_PREEMPT_BACK_STATUS_LIST,
                    ...ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST,
                  ].bjGet(scope.row[col.prop]))
                }}
              </template>
              <!-- #endif -->
              <template v-else-if="col.prop === 'suspendStatus'">
                {{
                  $t([
                    ...ORDER_INTERNAL_SKU_HAND_UP_STATUS_LIST,
                    ...ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST,
                  ].bjGet(scope.row[col.prop]))
                }}
              </template>
              <template v-else-if="col.prop === 'syncDeliveryStatus'">
                {{
                  $t([
                    ...ORDER_INTERNAL_SKU_STOCK_BACK_STATUS_LIST,
                    ...ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST,
                  ].bjGet(scope.row[col.prop]))
                }}
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="onDetail(scope.row)">{{ $t('viewText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- sku详情弹出框 -->
    <viewDialog ref="viewDialog"></viewDialog>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import viewDialog from './viewDialog.vue';
import { orderApi } from '@/api';
import {
  STATUS_YES_NUM,
  ORDER_INTERNAL_ORDER_STATUS_LIST,
  // #ifndef OPEN-SOURCE
  ORDER_INTERNAL_SKU_PREEMPT_STATUS_LIST,
  ORDER_INTERNAL_SKU_SOURCE_STATUS_LIST,
  // #endif
  ORDER_INTERNAL_SKU_PREEMPT_BACK_STATUS_LIST,
  ORDER_INTERNAL_SKU_DELIVER_STATUS_LIST,
  ORDER_INTERNAL_SKU_RECEIVING_STATUS_LIST,
  ORDER_INTERNAL_SKU_STOCK_BACK_STATUS_LIST,
  ORDER_INTERNAL_SKU_HAND_UP_STATUS_LIST,
  ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST,
  ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST,
  ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST,
  ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST,
  ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST,
  ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST,
  ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST,
  ORDER_BUSINESS_TYPES,
} from '@/utils/constants';

export default {
  name: 'BusinessOrderInternalViewSkuList',
  components: { viewDialog },
  mixins: [pageMiXin],
  props: {
    orderId: {
      type: String,
      default: null,
    },
    hasBtn: {
      type: Boolean,
      default: true,
    },
    hideSearch: {
      type: Boolean,
      default: false,
    },
    businessType: {
      type: String,
      default: ORDER_BUSINESS_TYPES.COMMON,
    },
  },
  data() {
    return {
      sortTableByOptionName: true,
      STATUS_YES_NUM,
      ORDER_INTERNAL_ORDER_STATUS_LIST,
      // #ifndef OPEN-SOURCE
      ORDER_INTERNAL_SKU_PREEMPT_STATUS_LIST,
      ORDER_INTERNAL_SKU_SOURCE_STATUS_LIST,
      // #endif
      ORDER_INTERNAL_SKU_PREEMPT_BACK_STATUS_LIST,
      ORDER_INTERNAL_SKU_DELIVER_STATUS_LIST,
      ORDER_INTERNAL_SKU_RECEIVING_STATUS_LIST,
      ORDER_INTERNAL_SKU_STOCK_BACK_STATUS_LIST,
      ORDER_INTERNAL_SKU_HAND_UP_STATUS_LIST,

      ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST,
      ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST,
      ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST,
      ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST,
      ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST,
      ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST,
      ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST,
      ORDER_BUSINESS_TYPES,
      queryApi: orderApi.getInternalSkuListByOrder,
      // 查询参数
      queryParams: {
        deliveryStatus: null,
        isOutStock: null,
        refundFlag: null,
        orderId: null,
        preemptionStatus: null,
        receiveStatus: null,
        sourceStatus: null,
        suspendStatus: null,
        syncDeliveryStatus: null,
        syncPreempStatus: null,
      },
      labelsVersion: 11,
      tableSortableDisabled: true,

      selectedRows: null,
    };
  },
  computed: {
    labelList() {
      const ARR = [
        { label: 'goodsPage.skuName', prop: 'skuName', isCheck: true, disabled: false },
        { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.SKU'), prop: 'standardSkuCode', isCheck: true, disabled: false },
        { label: this.$t('OrdinaryOrderMix.OrderItemTable.SPU'), prop: 'spuCode', isCheck: true, disabled: false },
        { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.Quantity'), prop: 'quantity', isCheck: true, disabled: false },
        { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.occupied'), prop: 'preemptionStatus', isCheck: true, disabled: false },
        { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.Sourcing'), prop: 'sourceStatus', isCheck: true, disabled: false },
      ];
      if (this.businessType == ORDER_BUSINESS_TYPES.O2O) {
        ARR.forEach(col => {
          if (col.prop == 'receivingStatus') {
            col.width = 'auto';
          }
          if (col.width == '74') {
            col.width = '128';
          }
          if (col.width < 100) {
            col.width = '100';
          }
        });

        const NOT_IN_O2O_STR =
          'deliveryStatus,preemptionStatus,sourceStatus,suspendStatus,syncPreempStatus,syncDeliveryStatus';
        NOT_IN_O2O_STR.split(',').forEach(key => {
          const INDEX = ARR.findIndex(col => col.prop == key);
          if (INDEX > -1) {
            ARR.splice(INDEX, 1);
          }
        });
      }
      return ARR;
    },
  },
  watch: {
    orderId: {
      handler(v) {
        if (v) {
          console.warn('SkuList', v);
          this.queryParams.orderId = v;
          this.$nextTick(() => {
            this.reFresh();
          });
        }
      },
      immediate: true,
    },
  },
  created() {},
  methods: {
    rowStyleFun({ row, rowIndex }) {
        const styleJson = {};
        if (row.stockFlag == 0 && this.$route.query.status == '4') {
          styleJson.color = 'red';
        }
        // if (['20103', '20104', '10103'].includes(row.preemptionStatus)) {
        //   styleJson.color = 'red';
        // }
        return styleJson;
    },
    afterFetchOriginalData(data) {
      this.$emit('afterFetchOriginalData', data);
    },
    resetDataFn(data) {
      return data.map(e => {
        return { BJ_HAS_CHILD: true, BJ_PARENT_ID: null, ...e };
      });
    },
    loadMethod({ row }) {
      // 异步加载子节点
      return new Promise((resolve, reject) => {
        orderApi
          .getInternalSkuLineListBySku({
            itemId: row.id,
          })
          .then(res => {
            const TEMP = (Array.isArray(res) ? res : []).map(e => {
              return { ...e, BJ_HAS_CHILD: false, BJ_PARENT_ID: row.id };
            });

            if (TEMP.length) {
              resolve(TEMP);
            } else {
              this.$message.warning(this.$t('OrdinaryOrderMix.GoodsInfoTab.back'));
              reject();
            }
          });
      });
    },
    handleSelectionChange(data) {
      this.selectedRows = data;
    },
    // 查看详情
    toView(r) {
      this.$refs.viewDialog.show(r);
    }
  },
};
</script>
